export class EquipmentUsedDuringRepair
{
    equipmentId?:number;
    subType?:string;
    manufacturer?:string;	
    modelNumber?:string	;
    serialNumber?:string	
    equipmentDescription?:string;
    dateCalibrated?:string;
    quantity?:number;
}